import React, {useEffect, useState} from "react";
import axios from "axios";
import {useParams} from "react-router-dom";
import {baseUrl} from "../Univ";

function VendorPaymentPrint() {

    const {id} = useParams();

    const [payment, setPayment] = useState({});
    const [invoice, setInvoice] = useState({});
    const [supplier, setSupplier] = useState({});
    const [items, setItems] = useState([]);

    useEffect(() => {

        loadData();

    }, []);

    const loadData = async () => {

        try {

            const res = await axios.get(
                baseUrl + "update-vendor-payment/" + id + "/"
            );

            setPayment(res.data);

            setInvoice(res.data.invoice);

            setSupplier(res.data.supplier);

            const itemRes = await axios.get(
                baseUrl + "purchase-order-item/" + res.data.invoice.id + "/"
            );

            setItems(itemRes.data);

        } catch (err) {

            console.log(err);

        }

    };

    const handlePrint = () => {

        const printContents =
            document.getElementById("invoice-print").innerHTML;

        const originalContents =
            document.body.innerHTML;

        document.body.innerHTML = printContents;

        window.print();

        setTimeout(() => {

            window.location.reload();

        }, 1000);

        document.body.innerHTML = originalContents;

    };
        return (

        <section>

            <div>

                <div id="invoice-print">

                    <div className="container mt-4">

                        <div className="row">

                            <div className="col-8">

                                <h2 className="fw-bold">
                                    E-Agri ERP
                                </h2>

                                <h5>Vendor Payment Voucher</h5>

                                <hr/>

                            </div>

                            <div className="col-4 text-end">

                                <h5>Payment No</h5>

                                <h4>{payment.id}</h4>

                            </div>

                        </div>

                        <div className="row mt-3">

                            <div className="col-md-6">

                                <h5 className="border-bottom pb-2">
                                    Supplier Details
                                </h5>

                                <table className="table-erp-modern">

                                    <tbody>

                                    <tr>
                                        <th width="35%">Supplier</th>
                                        <td>{payment.invoice?.supplier?.name}</td>
                                    </tr>

                                    <tr>
                                        <th>Mobile</th>
                                        <td>{payment.invoice?.supplier?.mobile}</td>
                                    </tr>

                                    <tr>
                                        <th>Email</th>
                                        <td>{payment.invoice?.supplier?.email}</td>
                                    </tr>

                                    <tr>
                                        <th>Address</th>
                                        <td>{payment.invoice?.supplier?.address}</td>
                                    </tr>

                                    </tbody>

                                </table>

                            </div>

                            <div className="col-md-6">

                                <h5 className="border-bottom pb-2">
                                    Payment Details
                                </h5>

                                <table className="table-erp-modern">

                                    <tbody>

                                    <tr>
                                        <th width="40%">Payment Date</th>
                                        <td>{payment.payment_date}</td>
                                    </tr>

                                    <tr>
                                        <th>Invoice No</th>
                                        <td>{invoice.invoice_no}</td>
                                    </tr>

                                    <tr>
                                        <th>PO No</th>
                                        <td>{invoice.po_no}</td>
                                    </tr>

                                    <tr>
                                        <th>Payment Mode</th>
                                        <td>{payment.payment_mode}</td>
                                    </tr>

                                    <tr>
                                        <th>Reference No</th>
                                        <td>{payment.reference_no}</td>
                                    </tr>

                                    <tr>
                                        <th>Status</th>
                                        <td>{payment.status}</td>
                                    </tr>

                                    </tbody>

                                </table>

                            </div>

                        </div>

                        <div className="mt-4">

                            <h5 className="border-bottom pb-2">

                                Invoice Items

                            </h5>

                            <table className="table-erp-modern">

                                <thead className="table-success">

                                    <tr>

                                        <th>S.No</th>

                                        <th>Item</th>

                                        <th>Quantity</th>

                                        <th>Rate</th>

                                        <th>Total</th>

                                    </tr>

                                </thead>

                                <tbody>

                                    {items.map((row, index) => (

                                        <tr key={row.id}>

                                            <td>{index + 1}</td>

                                            <td>{row.item.item_name}</td>

                                            <td>{row.quantity}</td>

                                            <td>{row.rate}</td>

                                            <td>{row.total}</td>

                                        </tr>

                                    ))}

                                </tbody>
                                            <tfoot>

                                <tr>

                                    <th
                                        colSpan="4"
                                        className="text-end"
                                    >
                                        Invoice Total
                                    </th>

                                    <th>

                                        ₹ {invoice.total}

                                    </th>

                                </tr>

                                </tfoot>

                            </table>

                        </div>

                        <div className="row mt-4">

                            <div className="col-md-6">

                                <h5 className="border-bottom pb-2">

                                    Payment Information

                                </h5>

                                <table className="table-erp-modern">

                                    <tbody>

                                    <tr>

                                        <th width="45%">
                                            Paid Amount
                                        </th>

                                        <td>
                                            ₹ {payment.amount}
                                        </td>

                                    </tr>

                                    <tr>

                                        <th>
                                            Balance
                                        </th>

                                        <td>
                                            ₹ {payment.balance}
                                        </td>

                                    </tr>

                                    <tr>

                                        <th>
                                            Transaction No
                                        </th>

                                        <td>
                                            {payment.reference_no}
                                        </td>

                                    </tr>

                                    <tr>

                                        <th>
                                            Payment Mode
                                        </th>

                                        <td>
                                            {payment.payment_mode}
                                        </td>

                                    </tr>

                                    </tbody>

                                </table>

                            </div>

                            <div className="col-md-6">

                                <h5 className="border-bottom pb-2">

                                    Remarks

                                </h5>

                                <div
                                    style={{
                                        minHeight: "120px",
                                        border: "1px solid #ddd",
                                        padding: "10px"
                                    }}
                                >

                                    {payment.remarks || "-"}

                                </div>

                            </div>

                        </div>

                        <br/>

                        <br/>

                        <table width="100%">

                            <tbody>

                            <tr>

                                <td align="left">

                                    ___________________________

                                    <br/>

                                    Prepared By

                                </td>

                                <td align="center">

                                    ___________________________

                                    <br/>

                                    Accounts Officer

                                </td>

                                <td align="right">

                                    ___________________________

                                    <br/>

                                    Authorized Signatory

                                </td>

                            </tr>

                            </tbody>

                        </table>

                    </div>

                </div>

                <div className="text-center mt-4 mb-5">

                    <button
                        className="btn btn-primary"
                        onClick={handlePrint}
                    >

                        Print Vendor Payment

                    </button>

                </div>

            </div>

        </section>

    );

}

export default VendorPaymentPrint;